import React, {Component} from 'react';
import {Grid, Row, Col, Tabs, Tab} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import WysylkaTabContainer from "./components/WysylkaTabContainer";
import HistoriaTabContainer from "./components/HistoriaTabContainer";
import OdKierowcowTabContainer from "./OdKierowcowTabContainer";

export default class PowiadomieniaContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 1,

        };
        this.changeActiveTab = this.changeActiveTab.bind(this)
    }


    renderContent() {
        if (this.state.activeTab === 1) {
            return <WysylkaTabContainer/>
        }
        else if (this.state.activeTab === 2) {
            return <HistoriaTabContainer/>
        }
        else if (this.state.activeTab === 3) {
            return <OdKierowcowTabContainer/>
        }
    }

    changeActiveTab(eventKey) {
        this.setState({activeTab: eventKey})
    }


    componentDidMount() {

    }


    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'OcenyContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{
                                    addressUrl: '/zarzadzanie-komunikatami',
                                    text: 'Zarządzanie komunikatami'
                                }, {addressUrl: '/zarzadzanie-komunikatami/powiadomienia', text: 'Powiadomienia'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col xs={12}>
                        </Col>
                        <Col sm={12}>
                            <Tabs defaultActiveKey={1} id="ebok-tab" onSelect={this.changeActiveTab}>
                                <Tab eventKey={1} title="Wysyłka">
                                </Tab>
                                <Tab eventKey={2} title="Historia">
                                </Tab>
                                <Tab eventKey={3} title="Od kierowców">
                                </Tab>
                            </Tabs>
                        </Col>
                        <Col sm={12}>
                            <div style={{marginTop: '15px'}}>
                                {this.renderContent()}
                            </div>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/komunikaty/powiadomienia/PowiadomieniaContainer.js